// Обработка прогресса загрузки

const TYPES = {
    processing: "Загружаю...",
    waiting: "Обрабатываю...",
};

const getPercentValue = function (e) {
    return Math.round((e.loaded / e.total) * 100);
};

export default {
    TYPES: TYPES,
    getPercentValue: getPercentValue,
};
